import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';

import { CommonBaseComponent } from '../common-base.component';

const patternPresets = {
  number: /^\d+$/,
};

@Component({
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    InputTextModule,
    TranslateModule,
  ],
})
export class TextFieldComponent extends CommonBaseComponent {
  @Input() maxLength: number = 250;

  constructor() {
    super();
  }

  testPattern(value: string, e: any) {
    const allow = this.item.config?.allow;
    if (!allow) return;
    const pattern =
      patternPresets[allow as keyof typeof patternPresets] || new RegExp(allow);
    if (!pattern.test(value)) {
      e.preventDefault();
    }
  }

  keyPress(e: KeyboardEvent) {
    this.testPattern(e.key, e);
  }

  paste(e: ClipboardEvent) {
    this.testPattern(e.clipboardData.getData('text'), e);
  }
}
